import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Chain, Heading, Section } from './Blocks';

const SEND_ICONS = ['image', 'camera-video', 'link-45deg', 'pencil-square'];

export default function Inspire() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const categories = t('landing.inspire.categories', { returnObjects: true });
  const [active, setActive] = useState(categories[0].id);
  const [picked, setPicked] = useState([]);
  const current = categories.find((c) => c.id === active) || categories[0];

  const toggle = (name) =>
    setPicked((p) => (p.includes(name) ? p.filter((x) => x !== name) : [...p, name]));

  const goPicked = () => {
    if (!picked.length) return;
    navigate(`/service-request?idea=${encodeURIComponent(picked.join(' ; '))}`);
  };

  return (
    <Section id="inspire" tone="inspire">
      <Heading kicker={`${t('landing.inspire.kicker')} · ${t('landing.inspire.name')}`} title={t('landing.inspire.title')} sub={t('landing.inspire.tagline')} />
      <p className="lead-line">{t('landing.inspire.lead')}</p>
      <p style={{ maxWidth: '70ch', marginBottom: '1rem' }}>{t('landing.inspire.body')}</p>
      <div className="tag-row">
        {t('landing.inspire.send', { returnObjects: true }).map((x, i) => (
          <span key={x} className="chip"><i className={`bi bi-${SEND_ICONS[i]}`} /> {x}</span>
        ))}
      </div>
      <p className="muted" style={{ margin: '1rem 0 2rem' }}>{t('landing.inspire.sendLead')}</p>

      <h3>{t('landing.inspire.galleryTitle')}</h3>
      <div className="toolbar" style={{ marginTop: '.75rem' }}>
        {categories.map((c) => (
          <button key={c.id} type="button" className={`chip ${active === c.id ? 'active' : ''}`} onClick={() => setActive(c.id)}>
            <i className={`bi bi-${c.icon}`} /> {c.name}
          </button>
        ))}
      </div>
      <div className="grid concepts">
        {current.items.map((name) => {
          const on = picked.includes(name);
          return (
            <button key={name} type="button" aria-pressed={on} className={`card concept ${on ? 'on' : ''}`} onClick={() => toggle(name)}>
              <i className={`bi bi-${current.icon}`} />
              <span>{name}</span>
              <i className={`bi ${on ? 'bi-check-circle-fill' : 'bi-plus-circle'} concept-mark`} />
            </button>
          );
        })}
      </div>
      <p className="disclaimer"><i className="bi bi-info-circle" /> {t('landing.inspire.disclaimer')}</p>
      <p className="muted">{t('landing.inspire.goalLine')}</p>

      <h3 style={{ margin: '2.25rem 0 .75rem' }}>{t('landing.inspire.twoWays')}</h3>
      <div className="grid cols2">
        <div className="card pad stack">
          <span className="badge blue" style={{ alignSelf: 'flex-start' }}>{t('landing.inspire.opt1.tag')}</span>
          <h3>{t('landing.inspire.opt1.t')}</h3>
          <p className="muted">{t('landing.inspire.opt1.d')}</p>
          <button type="button" className="btn accent" disabled={!picked.length} onClick={goPicked}>
            {t('landing.inspire.opt1.cta')}{picked.length ? ` (${picked.length})` : ''}
          </button>
          <small className="muted">
            {picked.length ? t('landing.inspire.selected', { count: picked.length }) : t('landing.inspire.opt1.pick')}
          </small>
        </div>
        <div className="card pad stack">
          <span className="badge blue" style={{ alignSelf: 'flex-start' }}>{t('landing.inspire.opt2.tag')}</span>
          <h3>{t('landing.inspire.opt2.t')}</h3>
          <p className="muted">{t('landing.inspire.opt2.d')}</p>
          <button type="button" className="btn accent" onClick={() => navigate('/service-request?idea=')}>
            {t('landing.inspire.opt2.cta')}
          </button>
        </div>
      </div>

      <h3 style={{ margin: '2.25rem 0 .75rem' }}>{t('landing.inspire.journeyTitle')}</h3>
      <ol className="grid steps journey8">
        {t('landing.inspire.journey', { returnObjects: true }).map((x, i) => (
          <li key={x} className="card pad step">
            <span className="step-n">{String(i + 1).padStart(2, '0')}</span>
            <span>{x}</span>
          </li>
        ))}
      </ol>

      <h3 style={{ margin: '2.25rem 0 .5rem' }}>{t('landing.inspire.missingTitle')}</h3>
      <p className="muted" style={{ maxWidth: '70ch', marginBottom: '1rem' }}>{t('landing.inspire.missingBody')}</p>
      <Chain items={t('landing.inspire.skills', { returnObjects: true })} />
      <p className="lead-line" style={{ marginTop: '1.5rem' }}>{t('landing.inspire.punch')}</p>
    </Section>
  );
}
